
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Contact() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-32 pb-24">
        <div className="container-custom max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-serif mb-12 text-center">REACHING THE MONASTERY</h1>
          
          <div className="text-center max-w-2xl mx-auto">
            <p className="mb-8">For inquiries about The Monastery Method:</p>
            
            <p className="mb-12 italic">
              Unlike medieval monasteries where one might wait days for a reply,<br/>
              We respond with slightly more haste.
            </p>
            
            <p className="text-xl mb-16">
              <a href="mailto:knock@themonasterymethod.com" className="hover:text-charcoal/70 transition-colors">
                knock@themonasterymethod.com
              </a>
            </p>
            
            <p className="italic mt-16 text-softgray">
              "Speak only if you can improve upon the silence."
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
